import React, { useRef, ChangeEvent, useState } from "react"
import { Button, IconUpload } from "dash-styled"
import { NavButton } from "../../../../../NavButton/NavButton"
import { routePaths } from "../../../../../../../Routes"

interface Props {
    layout: "absolute" | "relative"
    single?: boolean
    orgUsername: string
    onImport: (files: File[]) => void
    onDownloadExample: () => void
}

export const JSONButtons: React.FC<Props> = ({
    onImport,
    layout,
    single = false,
    orgUsername,
    onDownloadExample
}: Props) => {
    const input = useRef<HTMLInputElement>(null)
    const [importAttempts, setImportAttempts] = useState(0)
    const handleImportClick = () => {
        if (input.current) {
            input.current.click()
        }
    }
    const handleImport = async (event: ChangeEvent<HTMLInputElement>) => {
        const files: File[] = []

        for (let i = 0; i < (event.target.files?.length ?? 0); i++) {
            const item = event.target.files?.item(i)

            if (item !== null && item !== undefined) {
                files.push(item)
            }
        }

        setImportAttempts(i => i + 1)

        if (files.length > 0) {
            onImport(files)
        }
    }

    const btnClasses = "ml-2 text-gray-600 text-sm"

    const btnStyle = {
        display: "flex",
        justifyContent: "space-between",
        minWidth: "max-content",
        maxWidth: "min-content",
        flex: 1,
        alignItems: "center"
    }

    return (
        <div
            className={`relative ${
                layout === "relative" ? "flex justify-end" : ""
            }`}
        >
            <div
                className={`flex justify-end right-0 w-3/4 z-10 ${layout} -mt-1`}
            >
                {!single && (
                    <NavButton
                        color="white"
                        to={routePaths.datasets(orgUsername)}
                        className={btnClasses}
                        style={btnStyle}
                        size="xs"
                        variant="contained2"
                    >
                        <span className="flex mr-1">
                            <IconUpload size="sm" style={{ margin: 0 }} />
                        </span>
                        <span className="ml-1">Convert files to URLs</span>
                    </NavButton>
                )}
                <Button
                    onClick={onDownloadExample}
                    color="white"
                    className={btnClasses}
                    style={btnStyle}
                    size="xs"
                    variant="contained2"
                >
                    <span className="flex mr-1">
                        <IconUpload
                            size="sm"
                            style={{ margin: 0, transform: "rotate(180deg)" }}
                        />
                    </span>
                    <span className="ml-1 color-grey">
                        Download sample JSON
                    </span>
                </Button>
                <Button
                    onClick={handleImportClick}
                    color="white"
                    className={btnClasses}
                    style={btnStyle}
                    size="xs"
                    variant="contained2"
                >
                    <span className="flex mr-1">
                        <IconUpload size="sm" style={{ margin: 0 }} />
                    </span>
                    <span className="ml-1">Import JSON</span>
                </Button>
                <input
                    key={importAttempts}
                    type="file"
                    style={{ display: "none" }}
                    ref={input}
                    onChange={handleImport}
                    accept="application/json"
                />
            </div>
        </div>
    )
}
